var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ripple"},[_c('div',{staticClass:"ripple__circle"}),_c('div',{staticClass:"ripple__circle ripple__inner-circle"})])}]

export { render, staticRenderFns }